module.exports = __webpack_public_path__ + "img/Bahrodji-nologo.0dbd80b3.png";